<template>
  <v-row
    no-gutters
    class="mb-6"
  >
    <v-col
      :order="unit === 'metric' ? '1' : '2'"
      style="flex-grow: 0; flex-shrink: 0;"
      :style="{ flexBasis: dense ? '80px' : '100px' }"
      class="mr-2"
    >
      <validation-provider
        v-slot="{ errors }"
        rules="required|numeric|max_value:31|min_value:1"
      >
        <v-text-field
          v-model="day"
          outlined
          :dense="dense"
          :label="$t('text_input.data.day.title')"
          :placeholder="$t('text_input.data.day.placeholder')"
          type="text"
          pattern="[0-9]*"
          inputmode="numeric"
          hide-details
          :error-messages="errors || errorMessages"
          :error="errorMessages.length > 0"
          :disabled="disabled"
          @input="updateInput()"
        />
      </validation-provider>
    </v-col>
    <v-col
      :order="unit === 'imperial' ? '1' : '2'"
      style="flex-grow: 0; flex-shrink: 0;"
      :style="{ flexBasis: dense ? '80px' : '100px' }"
      class="mr-2"
    >
      <validation-provider
        v-slot="{ errors }"
        rules="required|numeric|max_value:12|min_value:1"
      >
        <v-text-field
          v-model="month"
          outlined
          :dense="dense"
          :label="$t('text_input.data.title')"
          :placeholder="$t('text_input.date.placeholder')"
          type="text"
          pattern="[0-9]*"
          inputmode="numeric"
          hide-details
          :error-messages="errors || errorMessages"
          :error="errorMessages.length > 0"
          :disabled="disabled"
          @input="updateInput()"
        />
      </validation-provider>
    </v-col>
    <v-col
      order="3"
      style="flex-grow: 0; flex-shrink: 0;"
      :style="{ flexBasis: dense ? '120px' : '160px' }"
    >
      <validation-provider
        v-slot="{ errors }"
        :rules="{ required: true, 'numeric': true, 'max_value': $dayjs().year(), 'min_value': $dayjs().year() - 120 }"
      >
        <v-text-field
          v-model="year"
          outlined
          :dense="dense"
          :label="$t('text_input.data.year.title')"
          :placeholder="$t('text_input.data.year.placeholder')"
          type="text"
          pattern="[0-9]*"
          inputmode="numeric"
          hide-details
          :error-messages="errors"
          :error="errorMessages.length > 0"
          :disabled="disabled"
          @input="updateInput()"
        />
      </validation-provider>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'DobInput',
  props: {
    value: {
      type: String,
      default: null
    },
    dense: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: () => ([])
    },
    unit: {
      type: String,
      default: 'metric'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      year: null,
      month: null,
      day: null,
      innerValue: null
    }
  },
  watch: {
    value() {
      this.loadDate()
    }
  },
  mounted() {
    this.loadDate()
  },
  methods: {
    loadDate() {
      if (!this.value) {
        this.year = null
        this.month = null
        this.day = null
        this.innerValue = null
      }

      if (this.value === this.innerValue) return

      const date = this.$dayjs(this.value)

      this.innerValue = this.value
      this.year = date.format('YYYY')
      this.month = date.format('MM')
      this.day = date.format('DD')
    },
    updateInput() {
      if (!this.year || !this.month || !this.day) return

      const date = `${this.year}-${this.month}-${this.day}`

      this.innerValue = date

      const d = this.$dayjs(date)

      if (d.isValid()) {
        this.innerValue = d.format('YYYY-MM-DD')
        this.$emit('input', d.format('YYYY-MM-DD'))
      }
    }
  }
}
</script>
